import React from "react";
import useIcons from "../../../hooks/useIcons";
import {iconNames} from "../../../constants/icon-names";

const NoResultsComponent = () => {
  const { getIcon } = useIcons();

  return (
    <div className="d-flex flex-column align-center">
      <span>{getIcon(iconNames.NORESULTS)}</span>
      <h2>Заявок не найдено</h2>
      <p>По вашему запросу не найдено соответствующих завок</p>
    </div>
  );
};

export default NoResultsComponent;
